/* eslint-disable import/prefer-default-export */
import { DEFAULT_REPORT_TAG } from '@/components/calendarEvents/utils/reportTagUtils';

export const initialState = {
  scroll: false,
  exludeDate: false,
  hasUnsavedChanges: false,
  loading: false,
  showModal: false,
  preselectVisitEvent: false,
  showReport: false,
  edit: {
    editPanel: false,
    editItem: false,
    editLoader: false,
    dateInstance: false,
    done: false,
    active: true,
  },
  endTimeSelected: false,
  dragTime: { start: '', end: '' },
  description: {
    active: false,
    text: '',
  },
  errors: {},
  types: {
    typeSelected: undefined,
    loading: false,
    typesError: undefined,
    typesData: [],
  },
  reports: {
    bodyTemplate: DEFAULT_REPORT_TAG,
    needReport: false,
    text: '',
    sendReportToContact: false,
    reportsTab: false,
    closureId: null,
    closures: [],
    closure: null,
    submitAttempted: false,
  },
  event: [
    {
      title: '',
      start: '',
      end: '',
    },
  ],
  repeat: {
    itemsDropDownRepeatEvent: [],
    dropDownRepeatEventIndex: 0,
    valueDropDownRepeatEvent: '',
    repeatItems: [],
    valueItems: { key: 'día', text: 'day' },
    numberRepeat: 1,
    isCustomRepeat: false,
    monthItems: [],
    valueMonth: '',
    monthDayPos: false,
    monthDayCode: false,
    valueMonthIndex: false,
    endEvent: { nunca: true, el: false },
    endDatePicker: false,
    repeatText: '',
    days: [
      { day: 'Sunday', active: false, text: 'sun', code: 'SU' },
      { day: 'Monday', active: false, text: 'mon', code: 'MO' },
      { day: 'Tuesday', active: false, text: 'tue', code: 'TU' },
      { day: 'Wednesday', active: false, text: 'wed', code: 'WE' },
      { day: 'Thursday', active: false, text: 'thu', code: 'TH' },
      { day: 'Friday', active: false, text: 'fri', code: 'FR' },
      { day: 'Saturday', active: false, text: 'sat', code: 'SA' },
    ],
    repeatItemsSingular: [
      { key: 'día', text: 'day' },
      { key: 'sem', text: 'week' },
      { key: 'mes', text: 'month' },
      { key: 'año', text: 'year' },
    ],
    repeatItemsPlural: [
      { key: 'día', text: 'days' },
      { key: 'sem', text: 'weeks' },
      { key: 'mes', text: 'months' },
      { key: 'año', text: 'years' },
    ],
  },
  notifications: {
    contactEmailBefore: false,
    agentNotioficationBefore: false,
    agentEmailBefore: false,
    agentNotificationAfter: false,
    agentEmailAfter: false,
    sendMailConfirmation: false,
  },
  agents: {
    agentsData: [],
    agentsSelected: [],
    loading: false,
    error: undefined,
  },
  properties: {
    propertiesData: [],
    propertiesSelected: [],
    loading: false,
    error: undefined,
  },
  contacts: {
    contactsData: [],
    contactsSelected: [],
    loading: false,
    error: undefined,
  },
};
